// lib/api/tasks/projects.ts
import { http } from '@/shared/api/http';

// Типы смарт-процессов (воронки)
export interface SmartProcessType {
  ID: number;
  EntityTypeID: number;
  Title: {
    String: string;
  };
  CreatedTime: string;
  TableName: string;
}

export interface SmartProcessTypesResponse {
  result: SmartProcessType[];
}

// Проекты (смарт-процессы)
export interface Project {
  id: number;
  entityTypeId: number;
  title: { String: string; Valid: boolean };
  stageId?: string;
  assignedById?: string;
  createdBy?: number;
  createdTime?: string;

  dateStart?: string;
  dateFinish?: string;
  stageName?: string;
  groupId?: number;
  totalTimeEstimate?: number;
  priority?: string;
  resume?: string;
  lastMessage?: string;

  company?: ANY;
  deal?: ANY;
  customFields?: Record<string, ANY>;
  contacts?: ANY[];
  // Файлы полей карточки, разложенные бэком по категориям (contract/tz/other).
  categorizedFiles?: Record<string, ANY[]>;
}

export interface ProjectsResponse {
  result: Project[];
}

// Получение типов смарт-процессов
export const fetchSmartProcessTypes =
  async (): Promise<SmartProcessTypesResponse> => {
    const response = await http.get('/smart_process/types');
    return response.data;
  };

// Получение списка проектов
export const fetchProjects = async (params?: {
  entityTypeId?: number;
  search?: string;
  page?: number;
  limit?: number;
  /** CSV id — резолв конкретных проектов по id (префилл). */
  ids?: string;
}): Promise<ProjectsResponse> => {
  const response = await http.get('/projects/list', { params });
  return response.data;
};

// Получение задач с фильтрацией по проектам
export const fetchTasksWithProjectFilter = async (params?: {
  page?: number;
  limit?: number;
  STATUS?: number;
  PERIOD?: string;
  GROUP_ID?: number;
  PROJECT_ENTITY_ID?: number;
  PROJECT_ENTITY_TYPE_ID?: number;
  RESPONSIBLE_ID?: number;
  CREATED_BY?: number;
}): Promise<ANY> => {
  const response = await http.get('/tasks/list', { params });
  return response.data;
};

// Воронки смарт-процессов
export interface SmartProcessFunnel {
  ID: number;
  Title: string;
  EntityTypeID?: number;
}

export interface SmartProcessFunnelsResponse {
  result: SmartProcessFunnel[];
}

// Получение списка воронок смарт-процессов
export const fetchSmartProcessFunnels =
  async (): Promise<SmartProcessFunnelsResponse> => {
    const response = await http.get('/smart_process/funnels');
    return response.data;
  };
